import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-two',
  templateUrl: './home-page-two.component.html',
  styleUrls: ['./home-page-two.component.scss']
})
export class HomePageTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
